import React from 'react'
import Navbar from './Navbar';
import StorySection from './StorySection';
import ServicesCollection from './ServicesCollection';
import Footer from './Footer';
import ReviewsSection from './ReviewsSection';
import LocationSection from './LocationSection';

export default function Home() {
  return (
    <>
      <Navbar />
      <StorySection />
      <ServicesCollection />
      <ReviewsSection />
      <LocationSection/> <br/>
      <Footer/>
    </>
  )
}
